var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQiuti(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1111 8.00003C15.1111 11.9274 11.9274 15.1111 8.00003 15.1111C4.07267 15.1111 0.888916 11.9274 0.888916 8.00003C0.888916 4.07267 4.07267 0.888916 8.00003 0.888916C11.9274 0.888916 15.1111 4.07267 15.1111 8.00003Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM8 15.1111C11.9274 15.1111 15.1111 11.9274 15.1111 8C15.1111 4.07264 11.9274 0.888889 8 0.888889C4.07264 0.888889 0.888889 4.07264 0.888889 8C0.888889 11.9274 4.07264 15.1111 8 15.1111Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 9.1852C14.05 7.27415 14.6667 5.03706 13.3334 3.25928C14.2222 4.44446 15.1111 5.62965 15.1111 8.00002C15.1111 13.9259 10.2222 15.1111 8.00002 15.1111C6.22224 15.1111 4.44446 14.5185 2.66669 12.7408C6.22224 16.2963 12.4445 11.5556 13.3334 9.1852Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQiuti);
export default __webpack_public_path__ + "static/media/qiuti.47e0466e3a4f6f0f600da60255b67203.svg";
export { ForwardRef as ReactComponent };